import { asWidgetProps } from 'Src/types/widget-helpers';
import React, { ComponentProps, useContext, useState } from 'react';
import { t } from 'Src/i18n';
import { Columns } from 'Components/frameworks/columns/Columns';
import { FilterButton } from 'Components/frameworks/filter-button/FilterButton';
import { Notification } from 'Components/frameworks/notification/Notification';
import { RentalsSectionTitle } from 'Components/widgets/rentals-section-title/RentalsSectionTitle';
import { RentalCard } from 'Components/widgets/rental-card/RentalCard';
import { ServicesContext, type ServicesContextType } from 'Context/ServicesContext';
type Props = {
  className?: string;
  colsNumber?: number;
  id?: string;
  rentals: Array<RentalEntity>;
  title: string;
};
const INITIAL_FILTER = {
  min: 0,
  max: 1440,
};
const ADULT_FILTER = {
  min: 144,
  max: 1440,
};
const CHILD_FILTER = {
  min: 0,
  max: 143,
};
export const RentalsFilteredList = ({
  className,
  colsNumber = 3,
  id,
  rentals = [],
  title,
}: Props) => {
  const [filter, setFilter] = useState(INITIAL_FILTER);
  const { bookingId } = useContext(ServicesContext) as ServicesContextType & {
    bookingId?: string;
  };

  if (!rentals?.length) {
    return null;
  }

  const list = rentals
    .filter((r) => r.ageRestriction.min >= filter.min && r.ageRestriction.max <= filter.max)
    .map((r) => (
      <RentalCard
        key={r.name}
        {...asWidgetProps<ComponentProps<typeof RentalCard>>({
          bookingId: bookingId,
          className: 'mb-20',
          rental: r,
        })}
      />
    ));
  return (
    <section className={className}>
      <RentalsSectionTitle
        {...asWidgetProps<ComponentProps<typeof RentalsSectionTitle>>({
          className: 'mb-20',
          id: id,
          isOnDemand: true,
        })}
      >
        {title}
      </RentalsSectionTitle>
      {rentals.length > 1 && (
        <div className="scroll-x scrollbar-hidden">
          <ul className="-m-5 mb-20 flex">
            <li className="p-5">
              <FilterButton
                {...asWidgetProps<ComponentProps<typeof FilterButton>>({
                  isActive: filter === INITIAL_FILTER,
                  onClick: () => setFilter(INITIAL_FILTER),
                })}
              >
                {t('common.activities.seeAll')}
              </FilterButton>
            </li>
            <li className="p-5">
              <FilterButton
                {...asWidgetProps<ComponentProps<typeof FilterButton>>({
                  isActive: filter === ADULT_FILTER,
                  onClick: () => setFilter(ADULT_FILTER),
                })}
              >
                {t('common.adultAndTeen')}
              </FilterButton>
            </li>
            <li className="p-5">
              <FilterButton
                {...asWidgetProps<ComponentProps<typeof FilterButton>>({
                  isActive: filter === CHILD_FILTER,
                  onClick: () => setFilter(CHILD_FILTER),
                })}
              >
                {t('common.child')}
              </FilterButton>
            </li>
          </ul>
        </div>
      )}
      {list.length ? (
        <Columns {...asWidgetProps<ComponentProps<typeof Columns>>({ colsNumber: colsNumber })}>
          {list}
        </Columns>
      ) : (
        <Notification
          {...asWidgetProps<ComponentProps<typeof Notification>>({
            text: t('common.rentals.noRentalsMessage'),
          })}
        />
      )}
    </section>
  );
};
